import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const HTMLTrans = (props) => {
  const page = props.id.split('.')[0];
  const defaultMessage = props.children;
  const variables = props.variables;

  if (props.translatedMessages
    && props.translatedMessages[page]
    && props.translatedMessages[page][props.id]) {
    let translatedMessage = props.translatedMessages[page][props.id];
    if (variables) {
      for (let key in variables) {
        translatedMessage = translatedMessage.replace(new RegExp(`{${key}}`, 'g'), variables[key]);
      }
    }

    return <span dangerouslySetInnerHTML={{ __html: translatedMessage }} />
  }

  return <span>{defaultMessage}</span>;
};

HTMLTrans.propTypes = {
  id: PropTypes.string.isRequired
};

const mapStateToProps = state => ({ translatedMessages: state.translations });

export default connect(mapStateToProps)(HTMLTrans);



// WEBPACK FOOTER //
// ./src/Common/Translations/HTMLTrans.js